import { Component, OnInit, AfterViewInit } from '@angular/core';
import {ParamMap, Router, ActivatedRoute,Params } from '@angular/router';
import { Http, ResponseContentType } from '@angular/http';
import {commonService} from "../../service/common.service";
import { sessionService } from '../../service/session.service';
import { ToppersService } from '../../service/toppers.service';
import { HttpErrorResponse } from '@angular/common/http';
import { userService } from '../../service/user.service';
import { Globals } from '../../globals';


@Component({
  selector: 'app-toppersdetail',
  templateUrl: './toppersdetail.component.html',
  styleUrls: ['./toppersdetail.component.css'],
  providers:[commonService,sessionService,Globals,ToppersService]
})
export class ToppersdetailComponent implements OnInit, AfterViewInit {

userId:any;
params:any={};
topperslistDagta:any;
imgUrl:any;
topperCatId:any;
  constructor(public tp:ToppersService,public router:Router,private route: ActivatedRoute,public global:Globals) {

    this.imgUrl = global.toppersUrl;
    this.topperCatId=global.ToppersCat;

   }

  
ngOnInit() { 
  const allParams = this.route.snapshot.params // allParams is an object
  const param1 = allParams.id;
   this.tp.getTopperDetailsById(param1).subscribe((data : any)=>{
    if(data){    
     this.topperslistDagta = data.results;
     //console.log(this.topperslistDagta);
  }
  else{ 
    this.topperslistDagta = {};      
  }
  });
 }

 empty(txt){
   if(txt){
    //let t = txt.replace(/\s/g, "");
    return txt;
   }else{
     return false;
   }
 }

 ngAfterViewInit(){
  var x = $("Books").html();
  //console.log(x);
 }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/toppersdetail/toppersdetail.component.ts